<script lang="ts">
	import {
		get_recipe,
		submit_recipe,
		get_aisle_options,
		get_tags,
	} from "../tastummy";
	import SelectCustom from "../general/SelectCustom.svelte";

	import { useParams } from "svelte-navigator";
	import type { Recipe, Tag } from "./recipe.types";
	import FilterPill from "../general/FilterPill.svelte";
	import Popup from "../general/Popup.svelte";
	const params = useParams();

	let loaded = false;
	let image: string;
	let recipe: Recipe;
	let aisles: string[] = [];
	let existing_tags: Tag[] = [];

	let tag_name = "";
	let add_tag_visible = false;

	let error = null;
	get_recipe($params.id)
		.then(async (r) => {
			let a = await get_aisle_options();
			aisles = a.data;
			recipe = r.data;
			image = recipe.image;
			loaded = true;
		})
		.catch((e) => {
			error = e;
			loaded = true;
		});

	get_tags().then((r) => {
		existing_tags = r.data;
	});

	function update_image() {
		recipe.image = image;
	}
	function submit() {
		// remove temp_id from ingredients
		recipe.ingredients = recipe.ingredients.map((i) => {
			if (i.id.startsWith("temp_")) {
				delete i.id;
			}
			return i;
		});
		submit_recipe(recipe).then(() => {
			window.location.pathname = "/recipe/" + recipe.id;
		});
	}
	function add_ingredient() {
		recipe.ingredients.push({
			id: "temp_" + Math.random(),
			amount: 0,
			unit: "",
			name: "",
			aisle: "",
			image: "",
			raw: "",
		});
		recipe = recipe;
	}
	function remove_ingredient(i: number) {
		/* remove ingredient at index i */
		recipe.ingredients.splice(i, 1);
		recipe = recipe;
	}
	function add_instruction() {
		let max_step_number = recipe.instructions.reduce((a, b) => {
			return Math.max(a, b.step);
		}, 0);

		recipe.instructions.push({
			step: max_step_number + 1,
			value: "",
			ingredients: [],
		});
		recipe = recipe;
	}
	function remove_instruction(i: number) {
		/* remove instruction at index i */
		recipe.instructions.splice(i, 1);
		recipe = recipe;
	}
	function add_tag(t: Tag) {
		recipe.tags.push(t);
		recipe = recipe;
	}
	function create_tag() {
		recipe.tags.push({ name: tag_name });
		recipe = recipe;
		existing_tags.push({ name: tag_name });
		existing_tags = existing_tags;
		add_tag_visible = false;
	}
	function remove_tag(val: string) {
		recipe.tags = recipe.tags.filter((x) => x.name !== val);
		recipe = recipe;
	}
</script>

<div class="container">
	{#if !loaded}
		loading
	{:else}
		{#if error}
			could not find recipe {error}
		{/if}
		<div id="edit-image-url">
			<label for="image-text-box">Image URL:</label>
			<textarea id="image-text-box" bind:value={image} />
			<img src={recipe.image} alt="recipe pic" />
			<button on:click={update_image}>Update Image</button>
		</div>
		<div>
			<label for="title">Title</label>
			<input type="text" id="title" bind:value={recipe.title} />
		</div>
		<div>
			<label for="imported">Imported</label>
			<input
				type="text"
				id="imported"
				readonly
				value={recipe.imported_date}
			/>
		</div>
		<div>
			<label for="source">Source</label>
			<input type="text" id="source" readonly value={recipe.source} />
		</div>

		<h1 class="grid-full">Tags</h1>
		<div class="tag-container grid-full">
			{#each existing_tags as tag (tag.name)}
				{#if recipe.tags.map((x) => x.name).indexOf(tag.name) === -1}
					<FilterPill
						on:click={() => {
							add_tag(tag);
						}}
						selected={false}
					>
						{tag.name}
					</FilterPill>
				{:else}
					<FilterPill
						on:click={() => {
							remove_tag(tag.name);
						}}
						selected={true}
					>
						{tag.name}
					</FilterPill>
				{/if}
			{/each}
			<button
				on:click={() => {
					add_tag_visible = true;
				}}>+</button
			>
			<Popup bind:visible={add_tag_visible}>
				<label for="tag_name_id">New Tag Name</label>
				<input
					class="new_tag_input"
					id="tag_name_id"
					bind:value={tag_name}
				/>
				<button on:click={create_tag}>Add</button>
			</Popup>
		</div>
		<div class="ingredient-container">
			<h1 class="grid-header">Ingredients</h1>
			{#each recipe.ingredients as ing, i (ing.id)}
				<div class="grid-header ingredient-row">
					<div>Ingredient:</div>
					<div>
						<input type="text" bind:value={ing.raw} />
					</div>
					<!-- <div>Amount:</div>
					<div>
						<input type="text" bind:value={ing.amount} />
					</div>
					<div>Measurement:</div>
					<div>
						<SelectCustom bind:value={ing.unit}>
							<option value="tsp">tsp</option>
							<option value="tbsp">tbsp</option>
							<option value="cups">cups</option>
							<option value="oz">oz</option>
							<option value="lb">lb</option>
							<option value="pint">pint</option>
							<option value="quart">quart</option>
							<option value="gallon">gallon</option>
							<option value="ml">ml</option>
							<option value="l">l</option>
							<option value="g">g</option>
							<option value="kg">kg</option>
						</SelectCustom>
					</div>
					<div>Ingredient:</div>
					<div>
						<input type="text" bind:value={ing.name} />
					</div>
					<div>Aisle:</div>
					<div>
						<select bind:value={ing.aisle}>
							{#each aisles as aisle}
								<option value={aisle}>{aisle}</option>
							{/each}
						</select>
					</div>
					<div>Current Value:</div>
					<div>
						<div>
							{ing.amount}
							{ing.unit}
							{ing.name}
							({ing.aisle})
						</div>
					</div> -->
					<div>
						<button
							on:click={() => remove_ingredient(i)}
							class="delete">X</button
						>
					</div>
				</div>
			{/each}
			<div class="add-ingredient-button">
				<button on:click={add_ingredient}>Add Ingredient</button>
			</div>
		</div>
		<div class="instruction-container">
			<h1 class="grid-header">Instructions</h1>
			{#each recipe.instructions as ins, i (ins.id)}
				<div>
					<input
						class="ins-number"
						type="text"
						bind:value={ins.step}
					/>
				</div>
				<div style="grid-column: 2 / 4">
					<textarea class="edit-text" bind:value={ins.value} />
					<!-- <input type="text" bind:value={ins.value} /> -->
				</div>
				<div style="grid-column: 4 / 6">
					{ins.step} -
					{ins.value}
				</div>
				<div>
					<button
						on:click={() => remove_instruction(i)}
						class="delete">X</button
					>
				</div>
			{/each}
			<div class="add-ingredient-button">
				<button on:click={add_instruction}>Add Instruction</button>
			</div>
		</div>
		<div>
			<button on:click={submit}>Save</button>
		</div>
	{/if}
</div>

<style>
	.container {
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		gap: 1em;
	}
	#edit-image-url {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.instruction-container {
		display: grid;
		grid-template-columns: repeat(6, 1fr);
		grid-column: 1 / -1;
		background-color: var(--background-2);
	}
	.ingredient-container {
		display: grid;
		grid-template-columns: repeat(6, 1fr);
		grid-column: 1 / -1;
		background-color: var(--background-2);
	}
	.tag-container {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		justify-content: left;
		align-items: flex-start;
	}
	.ingredient-row {
		display: flex;
		gap: 1em;
		align-items: center;
	}
	.add-ingredient-button {
		grid-column: 3 / 5;
	}
	.grid-header {
		grid-column: 1 / -1;
	}
	.ins-number {
		width: 50px;
	}

	.new_tag_input {
		background: var(--background-2);
	}
	img {
		max-width: 200px;
		max-height: 200px;
	}
	@media (max-width: 640px) {
		.instruction-container {
			grid-column: 1 / 4;
		}
		.ingredient-container {
			grid-column: 1 / 4;
		}
	}
</style>
